module.exports = __webpack_public_path__ + "img/competencies_rd_video_01.0b453076.jpg";